// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Kt7m","TextOnlyMenuButtonNSkin":"_2TFvc","textOnlyMenuButtonNSkin":"_2TFvc","linkElement":"_25Cim","wrapper":"_3zfdd","label":"_3YCIf"};